export interface CampaignVersion {
  major: number;
  minor: number;
  duration: 25 | 50;
}

export const skillsCompatibleGameVersions: Record<string, number[]> = {
  pb_solving: [20150],
  stress_manage: [20150],
  adaptability: [20150],
  active_listen: [20150, 20125],
  auto_efficient: [20150, 20125],
  decisions: [20150, 20125],
  empathy: [20150, 20125],
  planning: [20150],
  time_manage: [20150],
  leadership: [20150, 20125],
  learn_strategy: [20150, 20125],
  motivation: [20150, 20125],
}

/**
 * Get the campaign version object from the campaign version ID.
 * @param id The campaign version ID as a number with format `VvvDD` where V is major, vv is minor, and DD is duration. Minor and duration are padded with zeros if necessary.
 */
export function getVersionObjectFromVersionID(id: number): CampaignVersion | null {
  if (id < 10000) return null; // Invalid version ID
  const version = id.toString()
  const major = parseInt(version.slice(0, 1), 10);
  const minor = parseInt(version.slice(1, 3), 10);
  const duration = parseInt(version.slice(3, 5), 10) === 25 ? 25 : 50;

  return { major, minor, duration };
}

/**
 * Compute the campaign version ID based on the major, minor, and duration values.
 * @param version The campaign version object containing major, minor, and duration properties.
 * @returns The computed campaign version ID as a number with format `VvvDD` where V is major, vv is minor, and D is duration. Minor and duration are padded with zeros if necessary.
 */
export function computedCampaignVersionID(version: CampaignVersion): number {
  const major = version.major.toString().padStart(2, "0");
  const minor = version.minor.toString().padStart(2, "0");
  const duration = version.duration.toString().padStart(2, "0");

  return parseInt(`${major}${minor}${duration}`, 10);
}
